import { render, staticRenderFns } from "./UnknownBranchModal.vue?vue&type=template&id=de8ef748&"
import script from "./UnknownBranchModal.vue?vue&type=script&lang=js&"
export * from "./UnknownBranchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports